import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface ExpertInsightProps {
  quote: string;
  context: string;
}

const ExpertInsight = ({ quote, context }: ExpertInsightProps) => {
  return (
    <div className="bg-gradient-to-br from-primary/5 to-secondary/5 border border-primary/20 rounded-xl p-6 lg:p-8 shadow-natural">
      <div className="flex items-start space-x-4 mb-6">
        <div className="relative flex-shrink-0">
          <div className="w-16 h-16 rounded-full overflow-hidden border-2 border-primary">
            <AppImage
              src="/assets/images/Nupur_passport_photo-1767792792878.png"
              alt="Professional portrait of Dr. Nupur Mukherjee in white lab coat with confident smile in modern laboratory setting"
              className="w-full h-full object-cover" />

          </div>
          <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-conversion rounded-full border-2 border-card flex items-center justify-center">
            <Icon name="CheckBadgeIcon" size={16} className="text-conversion-foreground" />
          </div>
        </div>
        
        <div>
          <h4 className="font-heading font-bold text-lg text-text-primary">Dr. Nupur Mukherjee</h4>
          <p className="text-sm text-text-secondary">Founder & Environmental Scientist</p>
        </div>
      </div>
      
      <div className="relative">
        <Icon name="ChatBubbleLeftIcon" size={32} className="text-primary/20 absolute -top-2 -left-2" />
        <blockquote className="relative pl-8 mb-4">
          <p className="text-lg text-text-primary font-medium leading-relaxed italic">
            "{quote}"
          </p>
        </blockquote>
        
        <div className="bg-card/50 backdrop-blur-sm rounded-lg p-4 border border-border">
          <p className="text-sm text-text-secondary leading-relaxed">{context}</p>
        </div>
      </div>
    </div>);

};

export default ExpertInsight;